import { render, staticRenderFns } from "./courseUsageAnalysisReportFrom.vue?vue&type=template&id=481c7cff&scoped=true"
import script from "./courseUsageAnalysisReportFrom.vue?vue&type=script&lang=js"
export * from "./courseUsageAnalysisReportFrom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481c7cff",
  null
  
)

export default component.exports